import * as angular from "angular";
import {IController} from "angular";
import {CommonsAlertsService} from "../../services/commons-alerts.service";

export class bringozUploadFileCtrl implements IController {
  file: any;
  text?: string;
  description?: string;
  isDisabled: any;
  pattern: string;
  onChange: Function;

  constructor(private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    if (!this.file) {
      this.file = false;
    }
    // if (!this.pattern) {
    //   this.pattern = '.xls,.xlsx';
    // }
  }

  $onChanges(changes) {
    if (changes.file && !changes.file.isFirstChange()) {
      this.$onInit();
    }
  }


  uploadFiles(files, invalidFiles) {
    var file = files && files.length ? files[0] : undefined;
    if (invalidFiles.length>0) {
      this.commonsAlertsService.fileFormatError();
    }

    this.onChange({file: file});
  }

  onRemove() {
    if (!this.isDisabled) {
      this.onChange({file: undefined});
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozUploadFile', {
    bindings: {
      file: '<',
      text: '@?',
      description: '@?',
      isDisabled: '<',
      pattern: '@?',
      onChange: '&'
    },
    template: require('./bringoz-upload-file.html').default,
    controller: bringozUploadFileCtrl
  });
